import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  effect,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import {
  DataService as CoreDataService,
  PersistMode,
  QueryColumn,
  QueryColumnSortOrder,
} from "@barthauer/abc/core/data";
import {
  AbcPopupComponent,
  AbcTabPanelComponent,
  AbcToastComponent,
} from "@barthauer/abc/ui-components";
import { UserService } from "@barthauer/aptis-authentication";
import { Address } from "@barthauer/custom/arena";
import { loadMessages } from "devextreme/localization";
import { CustomArenaComponent } from "libs/custom/arena/src/lib/custom-arena.component";
import { merge, Observable, Subject } from "rxjs";
import { first, switchMap, takeUntil, tap } from "rxjs/operators";
import { FavoriteListComponent } from "./favorite-list/favorite-list.component";
import {
  Module,
  ActionType,
  PickListLanguage,
  Position,
  ROLES,
  ToastAnimationShowType,
  ToastType,
} from "./models/enumeration-list.model";
import { IToastAnimation, PositionIValue } from "./models/interfaces.model";
import { AppService } from "./services/app.service";
import { DataService, ObjectKeys } from "./services/data.service";
import { LanguageService } from "./services/language.service";
import { NotificationService } from "./services/notification.service";
import { CompaniesService } from "./shared/companies/companies.service";

import deMessages from "devextreme/localization/messages/de.json";
import enMessages from "devextreme/localization/messages/en.json";
import { Item } from "devextreme/ui/tree_view";
import ubtGeodsDe from "../../assets/resources/ubt-geods.de.json";
import ubtGeodsEn from "../../assets/resources/ubt-geods.en.json";
import { FavoritesService } from "./shared/favorite/favorites.service";
import { SupportPopupComponent } from "./shared/support-mail-popup/support-mail-popup.component";
import { ScreenService } from "./services/screen.service";
import { environment } from "../../environments/environment";
import {
  NotificationService1,
  NotificationSettingType,
} from "./services/notification1.service";
import { NotificationPopupComponent } from "./shared/notification/notification-popup/notification-popup.component";
import { dxTabPanelItem } from "devextreme/ui/tab_panel";
import { Property } from "@barthauer/custom/xmt-models";

export enum NavigationSvg {
  COMPANY = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M83.22,41.66v-12.73l-19.65-8.93-30.36,8.93v19.47l-16,4.71v46.89H99.22V48.93l-16-7.27Zm-22.01,52.34h-22v-14l-10,1v13h-6V57.6l23.91-7.03,14.09,6.41v37.03Zm16,0h-10V53.11l-19.65-8.93-8.36,2.46v-13.22l23.91-7.03,14.1,6.41v61.21Zm16,0h-10V48.25l10,4.55v41.2Z"/><polygon class="cls-1" points="47.12 63.18 55.21 65.85 55.21 60.26 47.12 56.59 47.12 63.18"/><polygon class="cls-1" points="47.12 75.81 55.21 77.49 55.21 71.51 47.12 69.22 47.12 75.81"/><polygon class="cls-1" points="47.12 88.33 55.21 88.33 55.21 82.96 47.12 81.74 47.12 88.33"/></svg>',
  HOME = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;fill-rule:evenodd;}</style></defs><path class="cls-1" d="M98.72,71,93,65.31V96H66V75H54V96H27V65.31L21.28,71,17,66.76,60,24l43,42.77ZM33,59.34V90H48V69H72V90H87V59.34L60,32.48Z"/></svg>',
  PROJECT = '<svg id=cls-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M87.58,61.22c-1.05,0-2.07-.08-3.08-.22v34.22H35.5V51.22h24V27.22h8.74c1.37-2.3,3.13-4.33,5.2-6h-19.14l-24.81,24.81v55.19h61V61.03c-.96,.12-1.93,.19-2.92,.19ZM53.5,30.51v14.71h-14.71l14.71-14.71Z"/><path class="cls-1" d="M104.77,41.94c.2-1.05,.31-2.12,.31-3.22,0-.95-.1-1.87-.24-2.77h-4.56c-.31-1.42-.86-2.75-1.59-3.95l3.25-3.25c-1.15-1.65-2.58-3.09-4.22-4.26l-3.24,3.24c-1.21-.76-2.55-1.33-3.99-1.66v-4.57c-.95-.16-1.92-.26-2.92-.26-1.05,0-2.07,.11-3.07,.29v4.59c-1.41,.34-2.74,.91-3.93,1.68l-3.23-3.23c-1.63,1.18-3.06,2.62-4.2,4.28l3.26,3.26c-.7,1.18-1.23,2.47-1.53,3.85h-4.56c-.15,.91-.24,1.83-.24,2.78,0,1.1,.11,2.17,.31,3.21h4.6c.34,1.32,.87,2.56,1.58,3.69l-3.24,3.24c1.17,1.64,2.61,3.07,4.26,4.22l3.25-3.25c1.12,.68,2.35,1.2,3.65,1.52v4.59c1,.18,2.03,.29,3.08,.29,.99,0,1.96-.1,2.91-.26v-4.57c1.33-.31,2.58-.82,3.72-1.49l3.26,3.26c1.66-1.14,3.1-2.57,4.28-4.2l-3.23-3.23c.74-1.15,1.3-2.43,1.65-3.79h4.6Zm-24.18-3.22c0-3.85,3.14-6.99,6.99-6.99s6.99,3.14,6.99,6.99-3.14,6.99-6.99,6.99-6.99-3.14-6.99-6.99Z"/><rect class="cls-1" x="42.49" y="58.22" width="6" height="6"/><rect class="cls-1" x="54.49" y="58.22" width="23.02" height="6"/><rect class="cls-1" x="42.5" y="70.22" width="5.99" height="6"/><rect class="cls-1" x="54.49" y="70.22" width="23.02" height="6"/><rect class="cls-1" x="42.5" y="82.22" width="5.99" height="6"/><rect class="cls-1" x="54.49" y="82.22" width="23.02" height="6"/></svg>',
  DASHBOARD = '<svg id="cls-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#007A93;}</style></defs><path class="cls-1" d="m33.5,1.75h-3.42c-2.62,0-4.75,2.13-4.75,4.75v7.42c0,2.62,2.13,4.75,4.75,4.75h3.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75Zm3.25,12.17c0,1.79-1.46,3.25-3.25,3.25h-3.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h3.42c1.79,0,3.25,1.46,3.25,3.25v7.42Z"/><path class="cls-1" d="m9.92,21.33h-3.42c-2.62,0-4.75,2.13-4.75,4.75v7.42c0,2.62,2.13,4.75,4.75,4.75h3.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75Zm3.25,12.17c0,1.79-1.46,3.25-3.25,3.25h-3.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h3.42c1.79,0,3.25,1.46,3.25,3.25v7.42Z"/><path class="cls-1" d="m6.5,18.67h11.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75H6.5C3.88,1.75,1.75,3.88,1.75,6.5v7.42c0,2.62,2.13,4.75,4.75,4.75ZM3.25,6.5c0-1.79,1.46-3.25,3.25-3.25h11.42c1.79,0,3.25,1.46,3.25,3.25v7.42c0,1.79-1.46,3.25-3.25,3.25H6.5c-1.79,0-3.25-1.46-3.25-3.25v-7.42Z"/><path class="cls-1" d="m33.5,21.33h-11.42c-2.62,0-4.75,2.13-4.75,4.75v7.42c0,2.62,2.13,4.75,4.75,4.75h11.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75Zm3.25,12.17c0,1.79-1.46,3.25-3.25,3.25h-11.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h11.42c1.79,0,3.25,1.46,3.25,3.25v7.42Z"/></svg>',
  MEASURE = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m23.98,13.05l-5.48,5.48-2.48-2.48c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l3.01,3.01c.15.15.34.22.53.22s.38-.07.53-.22l6.01-6.01c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0Z"/><path class="cls-1" d="m23.98,23.65l-5.48,5.48-2.48-2.48c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l3.01,3.01c.15.15.34.22.53.22s.38-.07.53-.22l6.01-6.01c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0Z"/><path class="cls-1" d="m31.08,5.04h-4.23c-.3-1.03-1.24-1.8-2.37-1.8h-.51c-.58,0-1.15-.23-1.72-.7-1.27-1.04-3.23-1.04-4.5,0-.39.32-1,.7-1.72.7h-.51c-1.13,0-2.07.76-2.37,1.8h-4.23c-1.2,0-2.17.97-2.17,2.17v28.87c0,1.2.97,2.17,2.17,2.17h22.16c1.2,0,2.17-.97,2.17-2.17V7.2c0-1.2-.97-2.17-2.17-2.17Zm-16.54.68c0-.54.44-.98.98-.98h.51c.92,0,1.84-.36,2.67-1.04.74-.61,1.86-.61,2.6,0,.83.68,1.75,1.04,2.67,1.04h.51c.54,0,.98.44.98.98v1.66c0,.21-.17.38-.38.38h-10.14c-.21,0-.38-.17-.38-.38v-1.66Zm17.2,30.35c0,.37-.3.67-.67.67H8.92c-.37,0-.67-.3-.67-.67V7.2c0-.37.3-.67.67-.67h4.13v.84c0,1.04.85,1.88,1.88,1.88h10.14c1.04,0,1.88-.85,1.88-1.88v-.84h4.13c.37,0,.67.3.67.67v28.87Z"/></svg>',
  TASK = '<svg id="cls-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1 {fill: #62829f;}</style></defs><path class="cls-1" d="m15.57,11.05l-3.68,3.68-1.36-1.36c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l1.89,1.89c.15.15.34.22.53.22s.38-.07.53-.22l4.21-4.21c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0Z"/><path class="cls-1" d="m26.7,19.55h-7.31c-.41,0-.75.34-.75.75s.34.75.75.75h7.31c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"/><path class="cls-1" d="m19.39,24.27h4.67c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-4.67c-.41,0-.75.34-.75.75s.34.75.75.75Z"/><path class="cls-1" d="m15.57,19.05l-3.68,3.68-1.36-1.36c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l1.89,1.89c.15.15.34.22.53.22s.38-.07.53-.22l4.21-4.21c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0Z"/><path class="cls-1" d="m26.7,27.55h-7.31c-.41,0-.75.34-.75.75s.34.75.75.75h7.31c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"/><path class="cls-1" d="m24.06,30.78h-4.67c-.41,0-.75.34-.75.75s.34.75.75.75h4.67c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"/><path class="cls-1" d="m15.57,27.05l-3.68,3.68-1.36-1.36c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l1.89,1.89c.15.15.34.22.53.22s.38-.07.53-.22l4.21-4.21c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0Z"/><path class="cls-1" d="m33.36,1.75H9.94c-1.2,0-2.17.97-2.17,2.17v1.13h-1.13c-1.2,0-2.17.97-2.17,2.17v28.87c0,1.2.97,2.17,2.17,2.17h23.42c1.2,0,2.17-.97,2.17-2.17v-1.13h1.13c1.2,0,2.17-.97,2.17-2.17V3.92c0-1.19-.97-2.17-2.17-2.17Zm-2.63,34.33c0,.37-.3.67-.67.67H6.64c-.37,0-.67-.3-.67-.67V7.22c0-.37.3-.67.67-.67h13.7c.37,0,.67.3.67.67v4.33h-1.61c-.41,0-.75.34-.75.75s.34.75.75.75h1.61v.36c0,.5.14.96.36,1.37h-1.98c-.41,0-.75.34-.75.75s.34.75.75.75h4.47s0,0,0,0h6.19c.37,0,.67.3.67.67v19.14Zm-1.89-21.31h-4.97c-.76,0-1.37-.62-1.37-1.37v-4.96l6.34,6.34Zm5.19,18.01c0,.37-.3.67-.67.67h-1.13v-16.51c0-.62-.26-1.18-.68-1.57h0s-9.64-9.64-9.64-9.64h0c-.4-.41-.95-.68-1.57-.68h-11.06v-1.13c0-.37.3-.67.67-.67h23.42c.37,0,.67.3.67.67v28.87Z"/></svg>',
  ADMINISTRATION = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m26.52,8.76c-2.62,0-4.75,2.13-4.75,4.75s2.13,4.75,4.75,4.75,4.75-2.13,4.75-4.75-2.13-4.75-4.75-4.75Zm0,8c-1.79,0-3.25-1.46-3.25-3.25s1.46-3.25,3.25-3.25,3.25,1.46,3.25,3.25-1.46,3.25-3.25,3.25Z"/><path class="cls-1"  d="m38.05,11.41h.02c-.06-.3-.3-.55-.62-.6l-1.79-.29c-.15-.47-.34-.93-.57-1.37l1.06-1.47c.19-.26.19-.6,0-.86-.8-1.16-1.8-2.16-2.96-2.96-.26-.18-.61-.18-.86,0l-1.47,1.06c-.44-.22-.9-.41-1.37-.57l-.29-1.79c-.05-.31-.29-.56-.61-.62-1.38-.25-2.8-.25-4.19,0-.31.06-.56.3-.61.62l-.29,1.79c-.47.15-.93.34-1.37.57l-1.47-1.06c-.26-.19-.6-.19-.86,0-.96.67-1.82,1.48-2.54,2.4h-6.62c-2.43,0-4.41,1.97-4.41,4.4v11c-.19.1-.38.22-.58.34-.27.17-.4.5-.32.8l.29,1.2c-.23.2-.44.41-.64.64l-1.2-.29c-.31-.07-.63.06-.8.32-.58.9-.99,1.9-1.22,2.94-.07.31.07.63.34.8l1.05.65c-.02.3-.02.6,0,.9l-1.05.64c-.27.17-.41.49-.34.8.12.55.27,1.05.47,1.53.2.48.44.94.75,1.41.17.27.49.4.8.32l1.2-.29c.2.23.41.44.64.64l-.29,1.2c-.07.31.06.63.32.8.9.58,1.9.99,2.94,1.22.31.07.63-.07.8-.34l.65-1.05c.3.02.6.02.9,0l.64,1.05c.17.27.49.41.8.34.55-.12,1.05-.27,1.53-.47.48-.2.94-.44,1.41-.75.27-.17.4-.49.32-.8l-.29-1.2c.23-.2.44-.41.64-.64l1.2.29c.31.07.63-.06.8-.32.12-.19.24-.39.35-.59h10.98c2.43,0,4.4-1.97,4.4-4.4v-6.6c.92-.72,1.74-1.58,2.41-2.55.18-.27.18-.61,0-.87l-1.06-1.47c.22-.44.41-.9.57-1.37l1.79-.29c.31-.05.56-.29.62-.61.13-.73.2-1.42.2-2.09s-.06-1.36-.2-2.09Zm-21.71,17.36c.06.5.07,1.01,0,1.5l-.06.48,1.39.85c-.15.52-.36,1.02-.62,1.49h-.01l-1.59-.38-.3.38c-.3.39-.66.75-1.06,1.06l-.38.3.38,1.59c-.24.14-.48.25-.73.35-.24.1-.49.19-.76.26l-.85-1.39-.48.06c-.5.07-1.01.07-1.5,0l-.48-.06-.85,1.39c-.52-.15-1.01-.36-1.49-.62l.38-1.59-.38-.3c-.39-.3-.75-.66-1.06-1.06l-.3-.38-1.59.38c-.14-.24-.25-.48-.35-.73-.1-.24-.19-.49-.26-.76l1.39-.86-.06-.48c-.06-.5-.07-1.01,0-1.5l.06-.48-1.39-.85c.15-.52.36-1.01.62-1.49l1.59.38.3-.38c.3-.39.66-.75,1.06-1.06l.38-.3-.38-1.59c.24-.14.48-.25.73-.35.24-.1.49-.19.76-.26l.86,1.39.48-.06c.5-.07,1.01-.07,1.5,0l.48.06.85-1.39c.52.15,1.01.36,1.49.62l-.38,1.59.38.3c.39.3.75.66,1.06,1.06l.3.38,1.59-.38c.14.24.25.48.35.73.1.24.19.49.26.76l-1.39.86.06.48Zm15.94.61c0,1.6-1.3,2.9-2.9,2.9l-.02-.02h-10.34c.09-.28.17-.56.23-.85.07-.31-.07-.63-.34-.8l-1.05-.64c.02-.3.02-.6,0-.9l1.05-.64c.27-.17.41-.49.34-.8-.12-.55-.27-1.05-.47-1.53s-.44-.94-.75-1.41c-.17-.27-.49-.4-.8-.32l-1.2.29c-.2-.23-.41-.44-.64-.64l.29-1.2c.07-.31-.06-.63-.32-.8-.9-.58-1.9-.99-2.94-1.22-.31-.07-.63.07-.8.34l-.64,1.05c-.3-.02-.6-.02-.9,0l-.64-1.05c-.17-.27-.49-.41-.8-.34-.3.07-.59.14-.87.23v-10.37c0-1.6,1.3-2.9,2.91-2.9h6.26l1.01,1.4c-.22.44-.41.9-.57,1.37l-1.79.29c-.31.05-.56.29-.62.61-.13.73-.2,1.42-.2,2.09s.06,1.36.2,2.09c.06.31.3.56.62.61l1.79.29c.15.47.34.93.57,1.37l-1.06,1.47c-.19.26-.19.6,0,.86.8,1.16,1.81,2.16,2.96,2.96.26.18.61.18.86,0l1.47-1.06c.44.22.9.41,1.37.57l.29,1.79c.05.31.29.56.61.62.73.13,1.42.2,2.09.2s1.36-.06,2.09-.2c.31-.06.56-.3.61-.62l.29-1.79c.47-.15.93-.34,1.37-.57l1.38,1v6.27Zm4.4-14.56l-2.19.35-.13.47c-.18.68-.45,1.32-.79,1.92l-.24.42,1.3,1.8c-.53.69-1.15,1.31-1.85,1.85l-1.8-1.3-.42.24c-.6.34-1.24.61-1.92.79l-.47.13-.35,2.19c-.9.12-1.71.12-2.61,0l-.35-2.19-.47-.13c-.68-.18-1.32-.45-1.92-.79l-.42-.24-1.8,1.3c-.69-.54-1.31-1.15-1.85-1.85l1.3-1.8-.24-.42c-.34-.6-.61-1.24-.79-1.92l-.13-.47-2.19-.35c-.06-.45-.09-.88-.09-1.3s.03-.86.09-1.31l2.19-.35.13-.47c.18-.68.45-1.32.79-1.92l.24-.42-1.3-1.8c.54-.69,1.15-1.31,1.85-1.85l1.8,1.3.42-.24c.6-.34,1.24-.61,1.92-.79l.47-.13.35-2.19c.9-.12,1.71-.12,2.61,0l.35,2.19.47.13c.68.18,1.32.45,1.92.79l.42.24,1.8-1.3c.69.54,1.31,1.15,1.85,1.85l-1.3,1.8.24.42c.34.6.61,1.24.79,1.92l.13.47,2.19.35c.06.45.09.88.09,1.31s-.03.86-.09,1.3Z"/><path class="cls-1"  d="m9.09,26.07c-1.9.79-2.8,2.97-2.02,4.87.59,1.43,1.99,2.3,3.45,2.3.47,0,.96-.09,1.42-.28,1.9-.79,2.8-2.97,2.02-4.87-.79-1.9-2.97-2.8-4.87-2.02Zm3.49,4.3c-.23.55-.66.98-1.21,1.21-.55.23-1.16.23-1.71,0-.55-.23-.98-.66-1.21-1.21-.23-.55-.23-1.16,0-1.71.23-.55.66-.98,1.21-1.21.27-.11.56-.17.85-.17s.58.06.85.17c.55.23.98.66,1.21,1.21.23.55.23,1.16,0,1.71h.01Z"/></svg>',
  DOCUMENTS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M96.29,64.36a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41c0-3.05,1.29-4.32,1.85-4.72h0a3,3,0,0,0,1.37-2.86,2.73,2.73,0,0,0-1.82-2.29c-.29-.22-1.4-1.29-1.4-4.43s1.29-4.32,1.85-4.72h0a3,3,0,0,0-.64-5.22L62.47,17.22a3,3,0,0,0-2.87.35L26.65,41.34h0c-1.3.94-4.34,3.76-4.34,9.58a12.5,12.5,0,0,0,2,7.25,12.52,12.52,0,0,0-2,7,12.56,12.56,0,0,0,2,7.26,12.46,12.46,0,0,0-2,7c0,7.51,4.38,9.67,4.88,9.9l.1,0,33.18,13.32a2.94,2.94,0,0,0,1.12.22,3,3,0,0,0,1.76-.57l33-23.77a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41C94.44,66,95.73,64.76,96.29,64.36Zm-67.11-17L56.76,58.39a13,13,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,55.37c-.27-.21-1.42-1.26-1.42-4.45A6.74,6.74,0,0,1,29.18,47.31Zm.32,8,.14.06-.12-.05Zm-.33,6.34L56.76,72.69a13.06,13.06,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,69.67c-.27-.21-1.42-1.26-1.42-4.45A6.81,6.81,0,0,1,29.17,61.62Zm.35,8h0l.12,0ZM90,61.48,62,81.69a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,55.71A12.59,12.59,0,0,0,90,61.48Zm0-14.3L62,67.39a8.09,8.09,0,0,1-.52-3.14c0-3.06,1.29-4.32,1.85-4.72L88.46,41.4A12.6,12.6,0,0,0,90,47.18ZM61.77,23.4,88.36,34.08,61.17,53.7,34.57,43ZM28.3,79.52a6.81,6.81,0,0,1,.87-3.6L56.76,87a13.06,13.06,0,0,0-1.27,5.86c0,.53,0,1,.06,1.5L29.61,83.93C29.51,83.85,28.3,82.76,28.3,79.52ZM62,96a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,70A12.55,12.55,0,0,0,90,75.78Z"/></svg>',
  MEASURETYPE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M70,20,40,50H52v4.49l-2-2-30,30H32V100H88V50h12ZM62,76.49V94H38V76.49H34.49L50,61,65.52,76.49ZM82,44V94H68V82.49H80l-22-22V44H54.48L70,28.49,85.51,44Z"/></svg>',
  TAG = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M88,20V14H82v6H38V14H32v6H20v80h80V20ZM32,26v6h6V26H82v6h6V26h6V46H26V26ZM26,94V52H94V94Z"/><rect class="cls-1" x="32" y="70.01" width="6" height="6"/><rect class="cls-1" x="32" y="82.01" width="6" height="6"/><rect class="cls-1" x="44" y="58" width="6" height="6"/><rect class="cls-1" x="44" y="70.01" width="6" height="6"/><rect class="cls-1" x="44" y="82.01" width="6" height="6"/><rect class="cls-1" x="56" y="58" width="6" height="6"/><rect class="cls-1" x="56" y="70.01" width="6" height="6"/><rect class="cls-1" x="56" y="82.01" width="6" height="6"/><polygon class="cls-1" points="83.89 57.88 78.01 63.76 72.13 57.88 67.88 62.13 73.76 68 67.88 73.89 72.13 78.13 78.01 72.25 83.89 78.13 88.13 73.89 82.25 68 88.13 62.13 83.89 57.88"/></svg>',
  SUBPROJECT = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m37.26,14.54c-.39-.46-.92-.77-1.5-.9v-.97c0-1.52-1.23-2.75-2.75-2.75h-13.01c-.59,0-1.14-.22-1.56-.63l-2.83-2.73c-.7-.68-1.63-1.05-2.61-1.05h-6c-1.52,0-2.75,1.23-2.75,2.75v5.39c-.58.13-1.11.44-1.51.9-.52.61-.75,1.42-.63,2.21l2.38,15.42c.21,1.35,1.35,2.33,2.72,2.33h25.57c1.37,0,2.51-.98,2.72-2.33l2.38-15.42c.12-.79-.11-1.6-.63-2.21ZM7,7h6c.59,0,1.14.22,1.56.63l2.83,2.73c.7.68,1.63,1.05,2.61,1.05h13.01c.69,0,1.25.56,1.25,1.25v.91H5.75v-5.33c0-.69.56-1.25,1.25-1.25Zm29.4,9.52l-2.38,15.42c-.1.61-.62,1.06-1.24,1.06H7.22c-.62,0-1.14-.45-1.24-1.06l-2.38-15.42c-.06-.36.05-.73.29-1,.24-.28.58-.44.95-.44h30.33c.37,0,.71.16.95.44.24.28.34.64.29,1Z"/><path class="cls-1" d="m22.71,22.74c-.29-.29-.77-.29-1.06,0s-.29.77,0,1.06l1.85,1.85h-5.3v-7.12c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7.87c0,.41.34.75.75.75h6.05l-1.85,1.85c-.29.29-.29.77,0,1.06.15.15.34.22.53.22s.38-.07.53-.22l3.13-3.13c.29-.29.29-.77,0-1.06l-3.13-3.13Z"/></svg>',
  REPORTS = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m33.57,12.07h0S23.94,2.43,23.94,2.43h0c-.4-.41-.95-.68-1.57-.68H7.91c-1.2,0-2.17.97-2.17,2.17v32.17c0,1.2.97,2.17,2.17,2.17h24.17c1.2,0,2.17-.97,2.17-2.17V13.64c0-.62-.26-1.18-.68-1.57Zm-9.04-6.93l6.34,6.34h-4.97c-.76,0-1.37-.62-1.37-1.37v-4.96Zm8.23,30.94c0,.37-.3.67-.67.67H7.91c-.37,0-.67-.3-.67-.67V3.92c0-.37.3-.67.67-.67h14.45c.37,0,.67.3.67.67v6.19c0,1.58,1.29,2.87,2.87,2.87h6.19c.37,0,.67.3.67.67v22.44Z"/><path class="cls-1" d="m11.5,8.25h7.31c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-7.31c-.41,0-.75.34-.75.75s.34.75.75.75Z"/><path class="cls-1" d="m11.5,11.49h4.12c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-4.12c-.41,0-.75.34-.75.75s.34.75.75.75Z"/><path class="cls-1" d="m28.51,16.47h-4.54c-.41,0-.75.34-.75.75s.34.75.75.75h2.73l-4.55,4.55-2.65-2.65c-.29-.29-.77-.29-1.06,0l-7.46,7.46c-.29.29-.29.77,0,1.06.15.15.34.22.53.22s.38-.07.53-.22l6.93-6.93,2.65,2.65c.29.29.77.29,1.06,0l5.08-5.08v2.73c0,.41.34.75.75.75s.75-.34.75-.75v-4.54c0-.41-.34-.75-.75-.75Z"/><path class="cls-1" d="m28.51,31.75H11.5c-.41,0-.75.34-.75.75s.34.75.75.75h17.01c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"/></svg>',
  STAFFMEMBERS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M60,103c-14.15,0-19.71-10.37-24.19-18.71-2.5-4.66-4.87-9.07-8.29-11.43C22.28,69.25,21,68.32,21,68.32a8.2,8.2,0,0,1-1.56-12A8.4,8.4,0,0,1,30.52,55l7.38,5.12c1.41,1,2.89,1.25,3.85.7s1.59-2.29,1.42-4.6l-2-27.09a8.2,8.2,0,0,1,8.37-8.8,8.38,8.38,0,0,1,8,7.82l.83,11.24,3.8-16.07a8.19,8.19,0,0,1,10.62-5.87,8.35,8.35,0,0,1,5.38,9.33,8,8,0,0,1,1.61-1.1A8.18,8.18,0,0,1,91.14,29.8a8.12,8.12,0,0,1,0,6.27L87,46.13l1.07-1.21a8.38,8.38,0,0,1,11.09-1.38h0a8.21,8.21,0,0,1,1.34,12.07s-5.93,7-11.84,13.39C84,74,81.77,79.74,79.57,85.32,76.15,94,72.61,103,60,103ZM25.63,59.47a2.12,2.12,0,0,0-1.63.7,2.21,2.21,0,0,0-.51,1.72,2.19,2.19,0,0,0,.92,1.52c.05,0,1.36,1,6.52,4.51,4.61,3.18,7.44,8.44,10.17,13.54C45.58,89.79,49.44,97,60,97c8.16,0,10.3-4.51,14-13.88,2.28-5.81,4.87-12.39,10.25-18.2,5.81-6.27,11.64-13.17,11.7-13.24a2.2,2.2,0,0,0-.33-3.29h0a2.35,2.35,0,0,0-3.06.5l-11,12.45a3.5,3.5,0,0,1-5.85-3.65l9.9-23.92a2.22,2.22,0,0,0,0-1.68,2.15,2.15,0,0,0-1.19-1.18,2.18,2.18,0,0,0-2.86,1.19L71.63,56a3.19,3.19,0,0,1-6.06-2l6.66-28.16a2.38,2.38,0,0,0-1.36-2.8,2.21,2.21,0,0,0-1.79.15A2.17,2.17,0,0,0,68,24.69L61.2,53.47a4,4,0,0,1-7.86-.62L51.56,28.58a2.37,2.37,0,0,0-2.14-2.26,2.17,2.17,0,0,0-1.65.68,2.14,2.14,0,0,0-.6,1.68l2,27.09c.34,4.71-1.27,8.44-4.43,10.25-3,1.71-6.92,1.33-10.25-1L27.1,59.92A2.67,2.67,0,0,0,25.63,59.47Z"/></svg>',
  ROLE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M85.86,80.14V28.28A11.58,11.58,0,0,0,74.29,16.71H28.57A11.58,11.58,0,0,0,17,28.28V39.86H34.14V91.72a11.58,11.58,0,0,0,11.57,11.57H91.43A11.58,11.58,0,0,0,103,91.72V80.14ZM23,33.86V28.28a5.57,5.57,0,0,1,11.14,0v5.58H23ZM40.14,91.72V28.28a11.56,11.56,0,0,0-1.43-5.57H74.29a5.58,5.58,0,0,1,5.57,5.57V80.14H51.28V91.72a5.57,5.57,0,0,1-11.14,0Zm56.86,0a5.58,5.58,0,0,1-5.57,5.57H55.85a11.56,11.56,0,0,0,1.43-5.57V86.14H97Z"/><path class="cls-1" d="M58.81,68.34l1.19.51,1.19-.51c.52-.22,12.67-5.59,12.67-16.91V39.36L60,34.06l-13.86,5.3V51.43C46.14,62.75,58.3,68.12,58.81,68.34ZM52.14,43.49l7.86-3,7.86,3v7.94c0,5.71-5.42,9.41-7.87,10.79-2.46-1.37-7.85-5-7.85-10.79Z"/></svg>',
  GANTT = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m36.5,21.12h-15.75v-2.23h10.75c.96,0,1.75-.79,1.75-1.75v-2.7c0-.96-.79-1.75-1.75-1.75h-10.75v-2.23h3.25c.96,0,1.75-.79,1.75-1.75v-2.7c0-.96-.79-1.75-1.75-1.75h-3.25v-1.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.75H3.5c-.96,0-1.75.79-1.75,1.75v2.7c0,.96.79,1.75,1.75,1.75h15.75v2.23h-3.25c-.97,0-1.75.79-1.75,1.75v2.7c0,.96.79,1.75,1.75,1.75h3.25v2.23h-10.75c-.96,0-1.75.79-1.75,1.75v2.7c0,.96.79,1.75,1.75,1.75h10.75v10.18c0,.41.34.75.75.75s.75-.34.75-.75v-10.18h15.75c.96,0,1.75-.79,1.75-1.75v-2.7c0-.96-.79-1.75-1.75-1.75Zm-12.5-15.37c.14,0,.25.11.25.25v2.7c0,.14-.11.25-.25.25h-3.25v-3.2h3.25ZM3.5,8.95c-.14,0-.25-.11-.25-.25v-2.7c0-.14.11-.25.25-.25h15.75v3.2H3.5Zm28,5.23c.14,0,.25.11.25.25v2.7c0,.14-.11.25-.25.25h-10.75v-3.2h10.75Zm-15.5,3.2c-.14,0-.25-.11-.25-.25v-2.7c0-.14.11-.25.25-.25h3.25v3.2h-3.25Zm-7.5,8.43c-.14,0-.25-.11-.25-.25v-2.7c0-.14.11-.25.25-.25h10.75v3.2h-10.75Zm28.25-.25c0,.14-.11.25-.25.25h-15.75v-3.2h15.75c.14,0,.25.11.25.25v2.7Z"/><path class="cls-1" d="m32.5,29.55h-7.5c-.96,0-1.75.79-1.75,1.75v2.7c0,.96.79,1.75,1.75,1.75h7.5c.96,0,1.75-.79,1.75-1.75v-2.7c0-.96-.79-1.75-1.75-1.75Zm.25,4.45c0,.14-.11.25-.25.25h-7.5c-.14,0-.25-.11-.25-.25v-2.7c0-.14.11-.25.25-.25h7.5c.14,0,.25.11.25.25v2.7Z"/></svg>',
  TRAINING_CENTER = '<svg id="uuid-df87eb3b-4cb9-4945-8987-d52c812b4f10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.uuid-dfc75c0b-010d-4640-a353-4743ed6dd12d{fill:#62829f;}</style></defs><path class="uuid-dfc75c0b-010d-4640-a353-4743ed6dd12d" d="m37.24,10.25l-15.46-7.69c-1.11-.55-2.44-.55-3.54,0L2.76,10.25c-.62.31-1.01.94-1.01,1.64s.39,1.32,1.01,1.64l3.55,1.77v12.94c0,.94.84,1.85,1.75,2.57-.31.44-.49.98-.49,1.56v3.95c0,.93,1.09,1.55,2.72,1.55s2.72-.62,2.72-1.55v-2.96c1.74.59,4.14,1.15,6.97,1.15,7.41,0,13.67-3.85,13.67-6.27v-12.93l3.58-1.78c.62-.31,1.01-.94,1.01-1.64s-.39-1.32-1.01-1.64Zm-27.7,6.64v8.92c-.77.22-1.4.76-1.72,1.48v-11.26l1.72.86Zm.75,12.75c-.67,0-1.22-.55-1.22-1.22s.55-1.22,1.22-1.22,1.22.55,1.22,1.22-.55,1.22-1.22,1.22Zm1.22,6.49c-.17.09-.59.23-1.22.23s-1.05-.14-1.22-.23v-3.77c0-.67.55-1.22,1.22-1.22s1.22.55,1.22,1.22v3.77Zm20.64-7.9c0,1.12-5.19,4.77-12.17,4.77-2.96,0-5.41-.66-7.06-1.27-.13-.52-.4-.98-.77-1.34.53-.5.86-1.2.86-1.97,0-1.24-.84-2.28-1.97-2.6v-8.17l7.19,3.58c.55.28,1.16.41,1.77.41s1.22-.14,1.77-.41l10.38-5.16v12.18Zm4.41-16.05l-15.46,7.69c-.69.34-1.52.34-2.21,0l-6.63-3.3,8.07-4.01c.37-.18.52-.63.34-1.01-.19-.37-.63-.52-1.01-.34l-9.09,4.52-7.15-3.56c-.16-.08-.18-.22-.18-.29s.02-.21.18-.29l15.46-7.69c.35-.17.72-.26,1.1-.26s.76.09,1.1.26l15.46,7.69c.16.08.18.22.18.29s-.02.21-.18.29Z"/></svg>',
  FAVORITE = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="M9.81,37.44c-.36,0-.73-.11-1.03-.34-.55-.4-.82-1.06-.7-1.72l1.64-9.56c.09-.55-.09-1.11-.49-1.49l-6.94-6.77c-.48-.47-.66-1.16-.45-1.81,.21-.64,.75-1.1,1.42-1.2l9.6-1.39c.55-.08,1.03-.43,1.27-.92L18.42,3.54c.3-.61,.9-.98,1.58-.98s1.28,.38,1.58,.98l4.29,8.69c.25,.5,.72,.84,1.27,.92l9.59,1.39c.67,.1,1.21,.56,1.42,1.2,.21,.64,.04,1.34-.45,1.81l-6.94,6.77c-.4,.39-.58,.95-.49,1.49l1.64,9.56c.11,.67-.16,1.33-.7,1.73-.54,.4-1.26,.45-1.86,.13l-8.58-4.51c-.49-.26-1.08-.26-1.57,0l-8.58,4.51c-.26,.14-.54,.2-.82,.2ZM20,4.06c-.06,0-.17,.02-.24,.15l-4.29,8.69c-.46,.94-1.36,1.59-2.4,1.74l-9.6,1.39c-.14,.02-.19,.12-.21,.18-.02,.06-.04,.17,.07,.27l6.94,6.77c.75,.73,1.09,1.79,.92,2.82l-1.64,9.56c-.02,.14,.06,.22,.1,.26,.05,.04,.15,.08,.28,.02l8.58-4.51c.93-.49,2.04-.49,2.97,0l8.58,4.51c.12,.07,.23,.02,.28-.02,.05-.04,.13-.12,.1-.26l-1.64-9.56c-.18-1.04,.17-2.09,.92-2.82l6.94-6.77c.1-.1,.08-.21,.07-.27-.02-.06-.07-.16-.21-.18l-9.59-1.39c-1.04-.15-1.94-.8-2.4-1.74l-4.29-8.69c-.06-.13-.18-.15-.24-.15Z"/></svg>',
  CONFIGPROJECT = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#62829f;}</style></defs><path class="cls-1" d="m21.33,6.5v7.42c0,2.62,2.13,4.75,4.75,4.75h7.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75h-7.42c-2.62,0-4.75,2.13-4.75,4.75Zm12.17-3.25c1.79,0,3.25,1.46,3.25,3.25v7.42c0,1.79-1.46,3.25-3.25,3.25h-7.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h7.42Z"/><path class="cls-1" d="m21.33,26.08v7.42c0,2.62,2.13,4.75,4.75,4.75h7.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75h-7.42c-2.62,0-4.75,2.13-4.75,4.75Zm12.17-3.25c1.79,0,3.25,1.46,3.25,3.25v7.42c0,1.79-1.46,3.25-3.25,3.25h-7.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h7.42Z"/><path class="cls-1" d="m1.75,6.5v7.42c0,2.62,2.13,4.75,4.75,4.75h7.42c2.62,0,4.75-2.13,4.75-4.75v-7.42c0-2.62-2.13-4.75-4.75-4.75h-7.42c-2.62,0-4.75,2.13-4.75,4.75Zm12.17-3.25c1.79,0,3.25,1.46,3.25,3.25v7.42c0,1.79-1.46,3.25-3.25,3.25h-7.42c-1.79,0-3.25-1.46-3.25-3.25v-7.42c0-1.79,1.46-3.25,3.25-3.25h7.42Z"/></svg>',
  POINT = `<svg id="Ebene_1" width="10px" height="10px" style="vertical-align: -webkit-baseline-middle;" id="cls-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 4"><defs><style>.cls-1{fill:#62829f;}</style></defs><circle class="cls-1" cx="2" cy="2" r="2"/></svg>`,
}

export enum Routes {
  COMPANIES = "/companies",
  COMPANIESLIST = "/companiesList",
  DASHBOARD = "/dashboard",
  SUBPROJECT = "/subProject",
  MEASURE = "/measures",
  TASK = "/tasks",
  REPORTS = "/reports",
  GANTT = "/gantt",
  TRAINING_CENTER = "/trainingCenter",
  PROJECT = "/project",
  STAFFMEMBERS = "/staffMembers",
  ROLES = "/roles",
  DOCUMENTS = "/documents",
  RIGHTS = "/roleRights",
}

import { ObjectTypeService } from "./services/object-type.service";

@Component({
  selector: "kis-core",
  templateUrl: "./core.component.html",
  styleUrls: ["./core.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [NotificationService],
  standalone: false,
})
export class CoreComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("toast", { static: false }) toast: AbcToastComponent;
  @ViewChild("customArena", { static: false })
  customArena: CustomArenaComponent;
  @ViewChild("notificationPopup", { static: true })
  notificationPopup!: NotificationPopupComponent;

  @ViewChild("resetPasswordPopUp") resetPasswordPopUp: AbcPopupComponent;

  @ViewChild("settingsTabPanel", { static: false })
  settingsTabPanel: AbcTabPanelComponent;

  @ViewChild("supportMailPopup", { static: false })
  supportMailPopup: SupportPopupComponent;
  private _favorites: FavoriteListComponent;
  @ViewChild("favorites", { static: false }) set favorites(
    favoritesComponent: FavoriteListComponent,
  ) {
    this._favorites = favoritesComponent;
    if (this._favorites && this.isFavoriteOpen) {
      this._favorites.openFavorites();
    }
  }
  public showMobileToggleIcon: boolean = false;
  public currentUserName: string;
  public shaderEnabled = false;
  public layoutTitle: string;
  public toolBarTitle: string;
  public menuMode = "shrink";
  public menuRevealMode = "expand";
  public minMenuSize = 0;
  public selectedRoute: string;
  public toastTemplate = "success";
  public toastMessage: string;
  public toastPosition: PositionIValue = {
    at: Position.TOP,
    my: Position.CENTER,
    offset: "0 60",
  };
  public toastAnimation: IToastAnimation = {
    show: {
      type: ToastAnimationShowType.SLIDE,
      duration: 200,
      from: { position: { my: Position.TOP, at: Position.BOTTOM } },
    },
  };
  public displayGoBackButton: boolean;
  public userAvatar: string;
  public logoIcon = this.appService.getSpecificInfo().logoIcon;
  public logoMiniatureIcon =
    this.appService.getSpecificInfo().logoMiniatureIcon;

  public isLoading = false;
  protected isSidebarOpen: boolean = true;
  private destroySubject: Subject<void> = new Subject();
  public selectedLanguage: string;
  public navigation: Item[] = [];
  public administrationNavigation: Item[] = [];
  public navigationToCompany: Item[] = [];
  public navigationToProject: Item[] = [];
  public companyName: string = "";
  public projectName = this.appService.projectName;
  public measureName = this.appService.measureName;
  public subProjectName = this.appService.subProjectName;
  public isFavoriteOpen = false;
  public visible: boolean = false;

  protected notificationByEmail: boolean = false;
  protected notificationInApp: boolean = false;
  protected emailNotificationLanguage: string;

  protected inAppNotificationSettingProperty: Property;
  protected emailNotificationSettingProperty: Property;
  protected emailLanguageNotificationSettingProperty: Property;

  protected NotificationSettingsTypes = NotificationSettingType;

  protected readonly unreadNotificationsCount = computed(
    () => this.notificationService1.unreadNotifications().length,
  );
  public columns: QueryColumn[] = [
    this.dataService.coreDataService.createQueryColumn(
      "Id",
      "Id",
      QueryColumnSortOrder.None,
    ),
  ];

  public contextMenuItems = [
    {
      text: () => {
        const displayText = JSON.parse(
          sessionStorage.getItem("ProfileSettings") || "[]",
        )?.[0]?.Value?.displayText;
        return displayText;
      },
      icon: "assets/images/right-left-arrow.svg",
      onClick: () => this.changeProfile(),
    },
    {
      text:
        sessionStorage.getItem("fixedCulture") === "de"
          ? "Sprache"
          : "Language",
      items: [
        {
          text: "German",
          onClick: () => {
            this.changeLanguage("de");
          },
        },
        {
          text: "English",
          onClick: () => {
            this.changeLanguage("en");
          },
        },
      ],
      icon: "assets/images/Aktualisierung.svg",
    },
    {
      text:
        sessionStorage.getItem("fixedCulture") === "de"
          ? "Einstellungen"
          : "Settings",
      icon: "assets/images/settings.svg",
      onClick: () => {
        this.openSettings();
      },
    },
    {
      text:
        sessionStorage.getItem("fixedCulture") === "de"
          ? "Ausloggen"
          : "Logout",
      icon: "assets/images/Ausloggen.svg",
      onClick: () => {
        this.logout();
      },
    },
  ];

  protected settingsTabs = [];
  protected languageOptions = [
    {
      text: "English",
      value: "en",
    },
    {
      text: "German",
      value: "de",
    },
  ];
  protected settingsPopupFullScreenMode: boolean = false;

  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private notificationService1: NotificationService1,
    public appService: AppService,
    private cdr: ChangeDetectorRef,
    public dataService: DataService,
    private languageService: LanguageService,
    private companiesService: CompaniesService,
    private userService: UserService,
    private favoriteService: FavoritesService,
    private readonly screenService: ScreenService,
    private objectTypeService: ObjectTypeService,
  ) {
    this.initTranslations();
    this.initNavigation();
    this.languageService.localStorageChanges$.subscribe((language) => {
      document.documentElement.lang = language;
    });
    this.router.events
      .pipe(takeUntil(this.destroySubject))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.router.navigated = false;
        }
      });
  }
  private initNavigation(): void {
    this.setupAdministrationNavigation();
    this.setupProjectNavigation();
    this.setupCompanyNavigation();
  }
  private initTranslations(): void {
    loadMessages(ubtGeodsEn);
    loadMessages(ubtGeodsDe);
    loadMessages(enMessages);
    loadMessages(deMessages);
  }
  ngOnInit() {
    this.objectTypeService.initializeObjectTypesList();
    this.settingsTabs = [
      {
        id: 1,
        title: this.dataService.res("Ubt-Settings-Popup-tabs-security"),
        icon: "user",
      },
      {
        id: 0,
        title: this.dataService.res("Ubt-Settings-Popup-tabs-notification"),
        icon: "bell",
      },
    ];
    merge(
      this.appService.treeViewSwitchToCompany$,
      this.appService.treeViewSwitchToProject$,
    )
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => {
        this.reinitializeNavigation();
      });
    //TODO ::-webkit-scrollbar height: 2px;
    this.switchTreeView();
    this.getProfileInformations();
    this.companiesService.companyName$
      .pipe(takeUntil(this.destroySubject))
      .subscribe((name: string) => {
        this.companyName = name;
      });
    this.notificationService.notification$
      .pipe(takeUntil(this.destroySubject))
      .subscribe((notification) => {
        this.toast.displayTime =
          notification.type === ToastType.ERROR ? 8000 : 9000;
        this.toast.visible = true;
        this.toast.width = "auto";
        this.toastMessage = notification.message;
        this.toastTemplate =
          notification.type === ToastType.SUCCESS
            ? "success"
            : notification.type === ToastType.INFO
              ? "info"
              : "error";
        this.toast.position = {
          at: "top",
          my: "center",
          offset: "0 60",
        };
        this.toast.animation = {
          show: {
            type: ToastAnimationShowType.SLIDE,
            duration: 200,
            from: { position: { my: Position.TOP, at: Position.BOTTOM } },
          },
        };
      });

    this.companyName = sessionStorage.getItem("companyName") || "";
    this.appService.projectName.set(
      sessionStorage.getItem("projectName") || "",
    );
    this.dataService
      .prepareUserData()
      .pipe(first())
      .subscribe((_profileIfno) => {
        if (_profileIfno !== undefined)
          this.dataService.setProfileInformations(_profileIfno);
      });

    this.appService.loader$
      .pipe(takeUntil(this.destroySubject))
      .subscribe((loader) => {
        Promise.resolve().then(() => {
          this.isLoading = loader;
        });
      });
  }
  private reinitializeNavigation(): void {
    this.setupAdministrationNavigation();
    this.setupProjectNavigation();
    this.setupCompanyNavigation();
    this.switchTreeView();
  }

  public setPicklistLanguage(fixedCulture: string): void {
    if (fixedCulture === "en")
      sessionStorage.setItem("pickListLanguage", PickListLanguage.English);
    else {
      sessionStorage.setItem("pickListLanguage", PickListLanguage.German);
    }
  }
  private async initializeLanguage() {
    let language: string = await this.userService.getAccountLanguage();
    if (!language) {
      language = environment.defaultLanguage;
      await this.userService.setAccountLanguage(language);
    }
    this.languageService.setValue("fixedCulture", language);
    this.setPicklistLanguage(language);

    // AFTER language is set, switch the tree view
    this.switchTreeView();
  }
  public changeLanguage = async (fixedCulture: string) => {
    if (sessionStorage.getItem("fixedCulture") === fixedCulture) return;
    this.isFavoriteOpen = false;
    const language = await this.userService.setAccountLanguage(fixedCulture);
    if (!language) return;
    this.languageService.setValue("fixedCulture", fixedCulture);
    this.setPicklistLanguage(fixedCulture);

    this.dataService
      .loadPermession(
        this.dataService.getRole(),
        this.dataService.addressPersonId,
      )
      .pipe(first())
      .subscribe(() => {
        this.sideNavTranslation();
        this.settingsTabs = [
          {
            id: 1,
            title: this.dataService.res("Ubt-Settings-Popup-tabs-security"),
            icon: "user",
          },
          {
            id: 0,
            title: this.dataService.res("Ubt-Settings-Popup-tabs-notification"),
            icon: "bell",
          },
        ];
        this.settingsTabPanel.instance.repaint();

        this.translateContextMenu();
        this.notificationService1.retranslateNotifications();
        this.router.navigate([this.router.url]);
      });
  };

  private translateContextMenu() {
    this.contextMenuItems[1].text = this.dataService.res(
      "Ubt-Measure-Language",
    );
    this.contextMenuItems[2].text = this.dataService.res("Ubt-Menu-Settings");
    this.contextMenuItems[3].text = this.dataService.res("Ubt-Menu-Logout");
  }
  public sideNavTranslation() {
    const currentLang = sessionStorage.getItem("fixedCulture");
    this.navigation = [
      ...this.navigation.map((item) => {
        if (item.component === "Ubt-TreeList-Administration" && item.items) {
          return {
            ...item,
            text: this.dataService.res(item.component),
            items: item.items.map((subItem) => ({
              ...subItem,
              text: this.dataService.res(subItem.component),
            })),
          };
        } else {
          return {
            ...item,
            text: this.dataService.res(item.component),
          };
        }
      }),
    ];
  }

  private applyResponsiveMenu() {
    const mobileItems = [
      {
        text:
          sessionStorage.getItem("fixedCulture") === "de"
            ? "Favoriten"
            : "Favorites",
        icon: "assets/images/Favorit.svg",
        mobileOnly: true,
        onClick: () => {
          this.openFavoriteSideBar();
        },
      },
      {
        text:
          sessionStorage.getItem("fixedCulture") === "de"
            ? "Unterstützung"
            : "Support",
        icon: "assets/images/Kontakt.svg",
        onClick: () => {
          this.openSupportPopup();
        },
        mobileOnly: true,
      },
    ];

    const width = window.innerWidth;

    this.settingsPopupFullScreenMode = width < 768;
    this.resetPasswordPopUp.width = width <= 1200 ? "80%" : "50%";
    this.settingsTabPanel.tabsPosition = width < 768 ? "top" : "left";

    this.isSidebarOpen = true;
    if (width < 1500 && width >= 1100) {
      this.isSidebarOpen = false;
    }
    if (width < 1100) {
      this.isSidebarOpen = false;

      this.customArena.shaderEnabled = true;
      this.customArena.minMenuSize = 0;
      this.showMobileToggleIcon = true;
      if (this.customArena.showMobileToggleIcon) {
        this.customArena._showMobileToggleIcon = true;
      }
      this.customArena.abcToolbar()?.instance._refresh();
      this.customArena.treeView()?.instance._refresh();
    }

    if (width < 970) {
      this.contextMenuItems.unshift(...mobileItems);
    }
  }
  ngAfterViewInit() {
    this.initializeLanguage();
    if (this.customArena) {
      window.addEventListener("resize", () => this.applyResponsiveMenu());
      this.applyResponsiveMenu();
    }
    if (this.router.url.includes("measureDetail")) {
      this.customArena.treeView()?.instance.selectItem(Routes.MEASURE);
    } else if (this.router.url.includes("subProjectDetail")) {
      this.customArena.treeView()?.instance.selectItem(Routes.SUBPROJECT);
    } else {
      this.customArena.treeView()?.instance.selectItem(this.router.url);
    }
  }

  ngOnDestroy() {
    this.destroySubject.next(null);
    this.destroySubject.complete();
  }

  public prepareCompaniesList(): Observable<Address[]> {
    const columns = [
      this.dataService.coreDataService.createQueryColumn("Id", "Id"),
      this.dataService.coreDataService.createQueryColumn("Name", "Name"),
    ];
    return this.dataService.readObjects<Address[]>(ObjectKeys.ADDRESS, columns);
  }

  private getProfileInformations(): void {
    const profileColumns = [
      this.dataService.coreDataService.createQueryColumn(
        "Id",
        "Id",
        QueryColumnSortOrder.None,
      ),
    ];
    const profileOPath =
      "Login=" + "'" + sessionStorage.getItem("userName") + "'";
    this.dataService
      .readObjects<{ Id: string }[]>(
        ObjectKeys.PERSON,
        profileColumns,
        profileOPath,
      )
      .pipe(
        tap((data) => {
          const profileId: string = data[0]?.Id;
          localStorage.setItem("profileId", profileId);
        }),
        switchMap((data) => {
          return this.notificationService1.getNotificationSettings(data[0]?.Id);
        }),
        takeUntil(this.destroySubject),
      )
      .subscribe({
        next: (data: Property[]) => {
          this.emailNotificationSettingProperty = data.find(
            (setting: Property) =>
              setting.Designation === NotificationSettingType.EMAIL,
          );
          this.inAppNotificationSettingProperty = data.find(
            (setting: Property) =>
              setting.Designation === NotificationSettingType.INAPP,
          );
          // default = true if not found
          this.notificationByEmail =
            this.emailNotificationSettingProperty?.BoolValue ?? true;
          this.notificationInApp =
            this.inAppNotificationSettingProperty?.BoolValue ?? true;
          this.selectedLanguage =
            this.emailNotificationSettingProperty?.TextValue ?? "de";
        },
        error: (error) => {
          console.error("Error fetching notification settings:", error);
        },
      });
  }

  private switchTreeView(): void {
    if (this.dataService.isSuperAdmin) {
      this.navigation = [...this.setUpSuperAdminNavigation()];
      this.sideNavTranslation();
      return;
    }
    this.appService.treeViewSwitchToCompany$.subscribe((data: boolean) => {
      if (data) {
        this.navigation = [...this.navigationToCompany];
        this.sideNavTranslation();
        this.cdr.detectChanges();
      } else {
        this.navigation = [...this.administrationNavigation];
        this.sideNavTranslation();
      }
    });

    this.appService.treeViewSwitchToProject$.subscribe((data: boolean) => {
      this.cdr.detectChanges();
      if (data) {
        this.navigation = [...this.navigationToProject];
        this.sideNavTranslation();
        this.cdr.detectChanges();
      } else {
        this.navigation = [...this.administrationNavigation];
        this.sideNavTranslation();
      }
    });

    if (localStorage.getItem("switchToProject") === "true") {
      this.navigation = [...this.navigationToProject];
      this.sideNavTranslation();
    } else if (localStorage.getItem("switchToCompany") === "true") {
      this.navigation = [...this.navigationToCompany];
      this.sideNavTranslation();
    } else {
      this.navigation = [...this.administrationNavigation];
      this.sideNavTranslation();
    }
  }

  public getLoginInfo(profileInfo): void {
    if (profileInfo) {
      this.appService.loggedInUserInformations.next({
        fullName:
          profileInfo.person.FirstName + " " + profileInfo.person.LastName,
        id: profileInfo.Id,
      });
    }
  }

  public onNavigationItemClick(event): void {
    this.measureName.set("");
    const favoriteElement = document.getElementsByClassName("favorite");
    favoriteElement[0]?.classList.remove("favorite");
    document.getElementById("container").style.opacity = "1";
    this.isFavoriteOpen = false;
    this.router.navigate([event.itemData.path]);
  }

  // @HostListener("document:click", ["$event.target"])
  onMouseClick(targetElement: HTMLElement): void {
    const favoriteButton = document.querySelector(".favorite-icon");
    const container = document.getElementById("container");
    const favouritesContainer = document.getElementById("favouritesContainer");

    if (container && favouritesContainer) {
      document.getElementById("favouritesContainer").style.opacity = "1";
      const favouritesButtonClicked = favoriteButton.contains(targetElement);
      const clickedInsideFavoritesContainer =
        favouritesContainer.contains(targetElement);

      if (!favouritesButtonClicked && !clickedInsideFavoritesContainer) {
        this.favorites?.closeFavorites();
        this.closeFavorites();
       
        document.getElementById("apllyOpacity").style.opacity = "1";
        this.cdr.detectChanges();
      }
    }
  }

  public redirectToCompanyList(): void {
    this.router.navigateByUrl("/companies");
    this.appService.isCompanySelected.set(false);
    this.subProjectName.set("");
    this.measureName.set("");
    // this.projectName.set("");
  }

  public redirectToProjectList(): void {
    this.router.navigateByUrl("/companies");
    this.appService.isCompanySelected.set(true);
    this.companiesService.selectedCompanyData(true);
    this.subProjectName.set("");
    this.measureName.set("");
  }

public openFavoriteSideBar = (): void => {
  this.isFavoriteOpen = !this.isFavoriteOpen;

  if (!this.isFavoriteOpen && this._favorites) {
    this._favorites.closeFavorites();
  }
};
  private createNavigationItem(
    textKey: string,
    component: string,
    path: string,
    icon: string,
    permission?: string,
    alwaysVisible = false,
  ): Item {
    return {
      text: this.dataService.res(textKey),
      component,
      path,
      icon,
      visible: alwaysVisible
        ? true
        : this.dataService.hasPermission(
            Module[this.dataService.getBasePath(path)],
            ActionType.SEE,
          ),
    };
  }
  private setUpSuperAdminNavigation(): Item[] {
    return [
      {
        text: this.dataService.res("Ubt-TreeList-Administration"),
        component: "Ubt-TreeList-Administration",
        icon: NavigationSvg.ADMINISTRATION,
        visible: true,
        isExpanded: true,
        items: [
          {
            text: this.dataService.res("Ubt-TreeList-Companies"),
            component: "Ubt-TreeList-Companies",
            path: Routes.COMPANIESLIST,
            icon: NavigationSvg.POINT,
            visible: true,
          },
          {
            text: this.dataService.res("Ubt-TreeList-StaffMembers"),
            component: "Ubt-TreeList-StaffMembers",
            path: Routes.STAFFMEMBERS,
            icon: NavigationSvg.POINT,
            visible: true,
          },
        ],
      },
    ];
  }
  private setupAdministrationNavigation(): void {
    this.administrationNavigation = [
      {
        text: this.dataService.res("Ubt-TreeList-Project-config"),
        component: "Ubt-TreeList-Project-config",
        path: Routes.COMPANIES,
        icon: NavigationSvg.CONFIGPROJECT,
      },
      {
        text: this.dataService.res("Ubt-TreeList-Administration"),
        component: "Ubt-TreeList-Administration",
        icon: NavigationSvg.ADMINISTRATION,
        visible: this.dataService.checkPermissionForAdministrationMenu([
          "Roles",
          "Companies",
          "Project",
          "roleRights",
          "Staff-Members",
        ]),
        isExpanded: false,
        items: [
          this.createNavigationItem(
            "Ubt-TreeList-Companies",
            "Ubt-TreeList-Companies",
            Routes.COMPANIESLIST,
            NavigationSvg.POINT,
            undefined,
            true,
          ),
        ],
      },
    ];
  }

  private setupProjectNavigation(): void {
    this.navigationToProject = [
      this.createNavigationItem(
        "Ubt-TreeList-Project-config",
        "Ubt-TreeList-Project-config",
        Routes.COMPANIES,
        NavigationSvg.CONFIGPROJECT,
        undefined,
        true,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Dashboard",
        "Ubt-TreeList-Dashboard",
        Routes.DASHBOARD,
        NavigationSvg.DASHBOARD,
      ),
      this.createNavigationItem(
        "Ubt-MeasureTask-SubProject",
        "Ubt-MeasureTask-SubProject",
        Routes.SUBPROJECT,
        NavigationSvg.SUBPROJECT,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Measures",
        "Ubt-TreeList-Measures",
        Routes.MEASURE,
        NavigationSvg.MEASURE,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Milestones-Tasks",
        "Ubt-TreeList-Milestones-Tasks",
        Routes.TASK,
        NavigationSvg.TASK,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Reports",
        "Ubt-TreeList-Reports",
        Routes.REPORTS,
        NavigationSvg.REPORTS,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Gantt",
        "Ubt-TreeList-Gantt",
        Routes.GANTT,
        NavigationSvg.GANTT,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-TrainingCenter",
        "Ubt-TreeList-TrainingCenter",
        Routes.TRAINING_CENTER,
        NavigationSvg.TRAINING_CENTER,
      ),
      {
        text: this.dataService.res("Ubt-TreeList-Administration"),
        component: "Ubt-TreeList-Administration",
        icon: NavigationSvg.ADMINISTRATION,
        isExpanded: false,

        visible: this.dataService.checkPermissionForAdministrationMenu([
          "Roles",
          "Companies",
          "Project",
          "roleRights",
          "Staff-Members",
          "Documents",
        ]),
        items: [
          this.createNavigationItem(
            "Ubt-TreeList-Companies",
            "Ubt-TreeList-Companies",
            Routes.COMPANIESLIST,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Project",
            "Ubt-TreeList-Project",
            Routes.PROJECT,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-StaffMembers",
            "Ubt-TreeList-StaffMembers",
            Routes.STAFFMEMBERS,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Roles",
            "Ubt-TreeList-Roles",
            Routes.ROLES,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Documents",
            "Ubt-TreeList-Documents",
            Routes.DOCUMENTS,
            NavigationSvg.POINT,
          ),
          {
            text: this.dataService.res("Ubt-User-Rights"),
            component: "Ubt-User-Rights",
            path: Routes.RIGHTS,
            icon: NavigationSvg.POINT,
            visible: this.dataService.hasAnyRole([ROLES.Admin]),
          },
        ],
      },
    ];
  }

  private setupCompanyNavigation(): void {
    this.navigationToCompany = [
      this.createNavigationItem(
        "Ubt-TreeList-Project-config",
        "Ubt-TreeList-Project-config",
        Routes.COMPANIES,
        NavigationSvg.CONFIGPROJECT,
        undefined,
        true,
      ),
      this.createNavigationItem(
        "Ubt-TreeList-Dashboard",
        "Ubt-TreeList-Dashboard",
        Routes.DASHBOARD,
        NavigationSvg.DASHBOARD,
      ),
      {
        text: this.dataService.res("Ubt-TreeList-Administration"),
        component: "Ubt-TreeList-Administration",
        icon: NavigationSvg.ADMINISTRATION,
        isExpanded: false,
        visible: this.dataService.checkPermissionForAdministrationMenu([
          "Roles",
          "Companies",
          "Project",
          "roleRights",
          "Staff-Members",
        ]),
        items: [
          this.createNavigationItem(
            "Ubt-TreeList-Companies",
            "Ubt-TreeList-Companies",
            Routes.COMPANIESLIST,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Project",
            "Ubt-TreeList-Project",
            Routes.PROJECT,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-StaffMembers",
            "Ubt-TreeList-StaffMembers",
            Routes.STAFFMEMBERS,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Roles",
            "Ubt-TreeList-Roles",
            Routes.ROLES,
            NavigationSvg.POINT,
          ),
          this.createNavigationItem(
            "Ubt-TreeList-Documents",
            "Ubt-TreeList-Documents",
            Routes.DOCUMENTS,
            NavigationSvg.POINT,
          ),
          {
            text: this.dataService.res("Ubt-User-Rights"),
            component: "Ubt-User-Rights",
            path: Routes.RIGHTS,
            icon: NavigationSvg.POINT,
            visible: this.dataService.hasAnyRole([ROLES.Admin]),
          },
        ],
      },
    ];
  }
  public openSupportPopup(): void {
    this.supportMailPopup.show();
  }

  public closeFavorites() {
   
    this.isFavoriteOpen = false;
    
  }

  public logout(): void {
    this.companiesService.prepareTitleCompany("");
    localStorage.clear();
    sessionStorage.clear();
    this.dataService.clearRoles();
    this.navigation = [...this.administrationNavigation];
    this.companyName = "Umsetzungsbegleitungstool";
    this.userService.logoutCurrentUser();
    this.favoriteService.allFavorites = undefined;
    this.favoriteService.favorites$ = null;
    this.appService.isCompanySelected.set(false);
    this.appService.projectList = [];
    this.emailNotificationSettingProperty = null;
    this.inAppNotificationSettingProperty = null;
    this.notificationService.notification$ = null;
    this.router.navigate(["/login"]);
  }

  private changeProfile(): void {
    const keepKeys = ["access_token", "LoginSettings"];

    Object.keys(localStorage).forEach((key) => {
      if (!keepKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    sessionStorage.clear();
    this.dataService.clearRoles();
    this.favoriteService.allFavorites = undefined;
    this.favoriteService.favorites$ = null;
    this.appService.isCompanySelected.set(false);
    this.appService.projectList = [];
    this.router.navigate(["/select-profile"]);
  }

  private openSettings(): void {
    this.resetPasswordPopUp.instance.show();
  }

  public afterPasswordReset(): void {
    this.resetPasswordPopUp.instance.hide();
  }
  protected menuToggle(value: boolean): void {
    this.screenService.isMenuOpened$.next(value);
  }

  protected openNotificationPopup() {
    Promise.resolve().then(() => {
      this.notificationPopup?.showPopup();
    });
  }

  protected persistNotificationSettings(
    identifier: string,
    enabled: boolean,
    propertyId: string,
    language?: string,
  ) {
    this.notificationService1
      .setNotificationSettings(
        propertyId ? PersistMode.Update : PersistMode.Insert,
        identifier,
        enabled,
        propertyId,
        language,
      )
      .subscribe((data: any) => {
        if (data) {
          if (identifier === NotificationSettingType.EMAIL) {
            if (!this.emailNotificationSettingProperty) {
              this.emailNotificationSettingProperty = { Id: data.Id } as any;
            } else {
              this.emailNotificationSettingProperty.Id = data.Id;
            }
            this.notificationService.callNotification({
              message: enabled
                ? this.dataService.res(
                    "notification.settings-emailNotification-enabled-toast-message",
                  )
                : this.dataService.res(
                    "notification.settings-emailNotification-disabled-toast-message",
                  ),
              type: enabled ? ToastType.SUCCESS : ToastType.INFO,
            });
          } else if (identifier === NotificationSettingType.INAPP) {
            if (!this.inAppNotificationSettingProperty) {
              this.inAppNotificationSettingProperty = { Id: data.Id } as any;
            } else {
              this.inAppNotificationSettingProperty.Id = data.Id;
            }
            this.notificationService.callNotification({
              message: enabled
                ? this.dataService.res(
                    "notification.settings-inAppNotification-enabled-toast-message",
                  )
                : this.dataService.res(
                    "notification.settings-inAppNotification-disabled-toast-message",
                  ),
              type: enabled ? ToastType.SUCCESS : ToastType.INFO,
            });
          }
        }
      });
  }

  // Use HostListener to check screen size on window resize
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    const screenSize = window.innerWidth;
    this.settingsPopupFullScreenMode = screenSize < 768;
    this.resetPasswordPopUp.width = screenSize <= 1200 ? "80%" : "50%";
    this.settingsTabPanel.tabsPosition = screenSize < 768 ? "top" : "left";
  }
}
